import React from "react";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import LockIcon from '@mui/icons-material/Lock';
import ImageIcon from '@mui/icons-material/Image';
import DescriptionIcon from '@mui/icons-material/Description';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

const GenerationSidebar = () => {
  return (
    <>
      <div className="editor_card">
        <h3>Generation</h3>
        <button className="regenerate_btn" style={{ marginBottom: '25px' }}>
          <AutoAwesomeIcon /> Regenerate Design
        </button>

        <h3>Design Info</h3>
        <ul className="design_info_list">
          <li>
            <span className="label">Design ID</span>
            <span className="value">AD-873A72D</span>
          </li>
          <li>
            <span className="label">Status</span>
            <span className="value">Generated</span>
          </li>
          <li>
            <span className="label">Created</span>
            <span className="value">May20, 2025 11:32 AM</span>
          </li>
          <li>
            <span className="label">Seed</span>
            <span className="value">5G7H2K9L</span>
          </li>
        </ul>

        <div className="claim_ownership_box">
          <div>
            <span className="title">Claim Ownership</span>
            <span className="subtitle">Lock & get certificate</span>
          </div>
          <LockIcon className="lock_icon" />
        </div>

        <div className="export_btn_group">
          <button className="export_btn">
            <img src="/static/images/pdf.svg" alt="PNG" style={{ width: '20px', height: '20px' }} /> PNG
          </button>
          <button className="export_btn">
            <img src="/static/images/pdf.svg" alt="SVG" style={{ width: '20px', height: '20px' }} /> SVG
          </button>
          <button className="export_btn">
            <img src="/static/images/pdf.svg" alt="PDF" style={{ width: '20px', height: '20px' }} /> PDF
          </button>
        </div>
      </div>

      <div className="editor_card">
        <h3>How It Works</h3>

        <div className="how_it_works_list">
          <div className="step_item">
            <div className="icon_circle"><img src="/static/images/step1.svg" alt="Generate" /></div>
            <div className="step_content">
              <h4>Generate</h4>
              <p>Our engine Create a Unique symmetrical design</p>
            </div>
          </div>
          <div className="step_item">
            <div className="icon_circle"><img src="/static/images/step2.svg" alt="Customize" style={{ width: '14px', height: '14px' }} /></div>
            <div className="step_content">
              <h4>Customize</h4>
              <p>Adjust colors, add overlays and text</p>
            </div>
          </div>
          <div className="step_item">
            <div className="icon_circle"><img src="/static/images/step3.svg" alt="Claim" style={{ width: '15px', height: '15px' }} /></div>
            <div className="step_content">
              <h4>Claim Ownership</h4>
              <p>Verify uniqueness and get your certificate</p>
            </div>
          </div>
          <div className="step_item">
            <div className="icon_circle"><img src="/static/images/step4.svg" alt="Export" style={{ width: '14px', height: '14px' }} /></div>
            <div className="step_content">
              <h4>Export</h4>
              <p>Download in PNG, SVG or PDF Formats</p>
            </div>
          </div>
        </div>

        <div className="security_badge">
          <img src="/static/images/shield_icon.svg" alt="Security" className="shield_icon" style={{ width: '24px', height: '24px' }} />
          <p>Every Design you Generate is 100% Unique and Protected.</p>
        </div>
      </div>
    </>
  );
};

export default GenerationSidebar;
